import { Component, Input } from '@angular/core'
import { closeJobSelectionDialog } from '../../../shared/utils/job-selection-dialog-utils'
import { PipelineType } from '../../../shared/model/jobs'
import { JobApiService } from '../../../shared/services/job-api.service'
import { Observable } from 'rxjs'
import { StaticLayerConfig } from '../../../state/viewer/viewer.state'
import { Store } from '@ngrx/store'
import { selectImageLayers } from '../../../state/viewer/viewer.selectors'
import { ToasterService } from '../../../shared/services/toaster.service'
import { HttpErrorResponse } from '@angular/common/http'
import { environment } from '../../../../environments/environment'

@Component({
    selector: 'app-nucleus-expansion-selection',
    templateUrl: './nucleus-expansion-selection.component.html',
    styleUrls: ['./nucleus-expansion-selection.component.scss'],
})
export class NucleusExpansionSelectionComponent {
    @Input()
    siblingDatasets: string[] | never[]
    imageLayers$: Observable<StaticLayerConfig[]>
    selectedTargetLayer: StaticLayerConfig | null = null
    submitted: boolean = false
    runBatchJob: boolean = false

    private readonly wikiUrl = environment.wikiUrl

    constructor(
        store: Store,
        private readonly jobApi: JobApiService,
        private readonly toaster: ToasterService
    ) {
        this.imageLayers$ = store.select(selectImageLayers)
    }

    get canStart(): boolean {
        return !!this.selectedTargetLayer && !this.submitted
    }

    cancel(): void {
        closeJobSelectionDialog()
    }

    startJob(): void {
        if (!this.canStart) return
        this.submitted = true

        this.jobApi
            .startNucleusExpansionJob({
                type: PipelineType.NucleusExpansion,
                target: this.selectedTargetLayer!.name,
                batch: this.runBatchJob,
            })
            .subscribe({
                next: () => closeJobSelectionDialog(),
                error: (err: HttpErrorResponse) => {
                    this.toaster.httpError(err, 'Error starting job')
                },
            })
    }

    chooseTargetLayer(layer: StaticLayerConfig): void {
        this.selectedTargetLayer = layer
    }

    // TODO: update wiki
    goToWiki(): void {
        window.open(`${this.wikiUrl}home/Working_with_jobs#h-nucleus-expansion`, '_blank')
    }
}
